module.exports = __webpack_public_path__ + "static/media/maf-17.1ecab090.png";